import React, { useEffect, useState } from "react";
import api, { API_BASE } from "@/lib/api";

/**
 * Fetches an authed file as a blob and renders it as an <img>.
 */
export default function AuthImage({ fileId, className, alt = "" }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;
    (async () => {
      try {
        const resp = await api.get(`/files/${fileId}`, { responseType: "blob" });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(resp.data);
        setUrl(objectUrl);
      } catch {
        setUrl(null);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileId]);

  if (!url) {
    return <div className={`bg-zinc-900 ${className || ""}`} />;
  }
  return <img src={url} alt={alt} className={className} />;
}
